/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401,
  PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500,
} from "../../types/individualPaymentInvoicesController/PostApiV1IndividualpaymentParcelsParcelidCancelInvoice.ts";

function getPostApiV1IndividualpaymentParcelsParcelidCancelInvoiceUrl(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/individualpayment/parcels/${parcelId}/cancel-invoice` as const,
  };
  return res;
}

/**
 * @description Marca a NF como cancelada; com 'reversePayment=true' estorna o pagamento (parcela paga volta a pendente). Migrado do legado IndividualPayment/CancelInvoice. **(Requer Authorization para autenticação)**
 * @summary Cancela a nota fiscal da parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/cancel-invoice}
 */
export async function postApiV1IndividualpaymentParcelsParcelidCancelInvoice(
  parcelId: PostApiV1IndividualpaymentParcelsParcelidCancelInvoicePathParams["parcelId"],
  params?: PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1IndividualpaymentParcelsParcelidCancelInvoiceMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice400
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice401
      | PostApiV1IndividualpaymentParcelsParcelidCancelInvoice500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1IndividualpaymentParcelsParcelidCancelInvoiceUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
